module.exports = __webpack_public_path__ + "static/media/pectineus_left_tension.9c6686e3.png";